// @ts-nocheck
import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";

/**
 * Se muestra cuando la dirección no-reply indicada para el área ya está asignada a otra.
 * No impide guardar: sólo pide la confirmación explícita del operador.
 */
export default function ConfirmarNoReplyDuplicado({ conflicto, onCancelar, onConfirmar, loading }) {
    return (
        <Dialog open={Boolean(conflicto)} onClose={onCancelar} maxWidth="sm" fullWidth>
            <DialogTitle>Dirección no-reply ya utilizada</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    La dirección <strong>{conflicto?.noReply}</strong> ya está asignada al área{" "}
                    <strong>{conflicto?.areaEnConflicto}</strong>.
                </DialogContentText>
                <DialogContentText sx={{ mt: 2 }}>
                    Si continúa, ambas áreas enviarán sus difusiones con el mismo remitente y compartirán
                    el límite diario de envíos.
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onCancelar} disabled={loading} sx={{ textTransform: "none" }}>
                    Cancelar
                </Button>
                <Button
                    onClick={onConfirmar}
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    sx={{ textTransform: "none" }}
                >
                    Guardar de todos modos
                </Button>
            </DialogActions>
        </Dialog>
    );
}
